import React, { useEffect } from 'react';

import { useHistory } from 'react-router-dom';
import { useRefreshToken } from '../Login/AuthToken';
import { Loading } from '../../Loading';
const Logout = () => {
  const [, , removeRefreshToken] = useRefreshToken();
  const history = useHistory();

  useEffect(() => {
    localStorage.clear();
    localStorage.clear();
    localStorage.clear();
    history.push('/login');
  });

  return (
    <div className="logout-login">
      <Loading />
      Logging out...Please wait..
    </div>
  );
};

export default Logout;
